/**************************************************
 * Nombre:       Seccion_Recibo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {PictureAsPdf} from '@mui/icons-material'
import {useEffect, useState} from "react";
import {obtenerIDTransaccion} from "../../Modulo_Wompi/Funciones/obtenerIDTransaccion";
import {PDFDownloadLink} from "@react-pdf/renderer";
import Pdf_Recibo from "../../Modulo_Wompi/Pdfs/Pdf_Recibo";
import logo from '../../Recursos/logo_color.png'
import {irArriba} from "../../Utilidades/irArriba";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {obtenerDatosTransaccion} from "../../Modulo_Wompi/Funciones/obtenerDatosTransaccion";
import {adap_datos_recibo} from "../../Modulo_Wompi/Adaptadores/adap_datos_recibo";
import {actualizarDoc} from "../../Servicios/BD/actualizarDoc";


const Seccion_Recibo = () => {
    const [datos, setDatos] = useState({})
    const [pedido, setPedido] = useState({})
    const [cargando, setCargando] = useState(false)


    const actualizarCompra = async (data) => {

        //console.log(data)
        let w = [where('consecutivo', '==', data.consecutivo)]
        let doxPedido = await obtenerColWheres({col: 'pedidos', wheres: w})
        // console.log(doxPedido)
        if (!doxPedido.res || !doxPedido.data[0]) return

        let pedido = doxPedido.data[0]

        if (pedido.estado !== data.estado) {
            let actualizaciones = {
                valorPagado: data.valorPagado,
                metodo: data.metodo,
                idTransaccion: data.idTransaccion,
                fechaPago: data.fechaPago,
                estado: data.estado
            }

            let doxAct = await actualizarDoc({col: 'pedidos', id: pedido.id, datos: actualizaciones})
            if (!doxAct.res) return

            console.log({...pedido, ...actualizaciones})
            setPedido({...pedido, ...actualizaciones})

            await actualizarSuscriptor({...pedido, ...actualizaciones})

        } else {
            setPedido(pedido)
        }


    }


    const actualizarSuscriptor = async (pedido) => {


        let w = [where('correo', '==', pedido.correo)]
        let dox = await obtenerColWheres({col: 'suscriptores', wheres: w})
        if (dox.data && dox.data[0]) {
            let id = dox.data[0].id
            await actualizarDoc({col: 'suscriptores', id: id, datos: {ciudad: pedido.ciudad}})
        }


    }


    useEffect(() => {
        irArriba()

        setCargando(true)
        let idTransaccion = obtenerIDTransaccion("id")

        obtenerDatosTransaccion(idTransaccion).then((dox) => {
            // console.log(dox)
            let dats = adap_datos_recibo(dox)
            setDatos(dats)
            actualizarCompra(dats).then()
            setCargando(false)
        })


    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{px: 3}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{mt: 8}}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{color: theme.palette.primary.main}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Typography sx={{fontSize: 24, fontWeight: 300}}>{`PEDIDO #${datos.consecutivo}`}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 0}}>
                        <Typography sx={{fontSize: 24, fontWeight: 300, textAlign: 'center'}}>EL ESTADO DE SU PAGO ES
                            <span style={{fontWeight: 800}}> {datos.estado}</span>
                        </Typography>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'center', mt: 2}}>
                        <Typography sx={{fontSize: 24, fontWeight: 300, textAlign: 'center'}}>
                            En ÂMEVI, creemos que la moda es más que ropa: es una extensión de tu esencia y una
                            expresión de tu alma viva.
                            <br/>
                            Las prendas que elegiste fueron pensadas para inspirarte a vivir con <span
                            style={{fontWeight: 300}}> autenticidad, confianza
                            y estilo. </span>
                            <br/>
                            <br/>
                            <span style={{fontWeight: 800}}>
                            ¡Gracias por elegirnos y permitirnos ser parte de tu historia!
                                 </span>
                            <br/>
                            Tu pedido será despachado el día hábil siguiente a tu compra.

                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                        {pedido && pedido.id ?
                            <PDFDownloadLink document={<Pdf_Recibo logo={logo} datos={datos} pedido={pedido}/>}
                                             fileName={"Comprobante de compra " + pedido.consecutivo}
                                             style={{textDecoration: "none"}}>
                                <Button
                                    loading={cargando}
                                    startIcon={<PictureAsPdf/>}
                                    sx={{fontSize: 16, px: 6, py: 2}}>DESCARGAR COMPROBANTE</Button>
                            </PDFDownloadLink>

                            :

                            <Button
                                loading={cargando}
                                startIcon={<PictureAsPdf/>}
                                sx={{fontSize: 16, px: 6, py: 2}}>DESCARGAR COMPROBANTE</Button>


                        }

                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                        <Typography sx={{fontSize: 24, fontWeight: 300, textAlign: 'center'}}>
                            Si necesitas algo, estamos aquí para ti:
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                        <Typography sx={{fontSize: 20, fontWeight: 800, textAlign: 'center'}}>
                            WhatsApp
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: -1}}>
                        <Typography sx={{fontSize: 20, fontWeight: 300, textAlign: 'center'}}>
                            +57 320 399 5058
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                        <Typography sx={{fontSize: 20, fontWeight: 800, textAlign: 'center'}}>
                            Correo
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: -1, mb: 12}}>
                        <Typography sx={{fontSize: 20, fontWeight: 300, textAlign: 'center'}}>
                            contacto@amevi.com.co
                        </Typography>
                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )

}
export default Seccion_Recibo